import { useEffect } from "react";
import { selectCurrentSpaceId } from "modules/space/redux/selectors";
import { selectUser } from "modules/auth/redux/selectors";
import { useSelector } from "react-redux";
import { useDevices, useIsTalking } from "modules/audioVideo/hooks";
import {
  useLocalSessionId,
  useParticipantProperty,
} from "@daily-co/daily-react";
import useUserStatusActions from "./hooks/useUserStatusActions";

const UserStatusContainer = () => {
  const spaceId = useSelector(selectCurrentSpaceId);
  const user = useSelector(selectUser);
  const userId = user ? user.id : null;
  const { cameraActive, microphoneActive, screenShareActive } = useDevices();
  const id = useLocalSessionId();
  const [audioTrack] = useParticipantProperty(id, [
    "tracks.audio.persistentTrack",
  ]);
  const { isTalking } = useIsTalking({
    audioTrack,
  });

  const { subscribe, unsubscribe, updateUserStatus } = useUserStatusActions();

  useEffect(() => {
    if (!spaceId || !userId) {
      return;
    }

    updateUserStatus({
      spaceId,
      userId,
      data: {
        // below are used in useRelationshipsTracking
        isCameraOn: cameraActive,
        isMicrophoneOn: microphoneActive,
        isTalking, // speaking waves
        isScreenSharing: screenShareActive, // avatar status -> screenshare icon
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    spaceId,
    userId,
    cameraActive,
    microphoneActive,
    screenShareActive,
    isTalking,
  ]);

  useEffect(() => {
    subscribe({ spaceId });

    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default UserStatusContainer;
